/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="./employeeMover.controller.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class EmployeeMover implements angular.IDirective {
        restrict = 'E';
        templateUrl = 'app/components/controls/employeeMover/employeeMover.template.html';
        scope = {
            securityAccess: '=?',
            availabilityFilter: '=?',
            centralOffice: '=?',
            withCategories: '=?',
            categoriesList: '=?',
            hierarchyBusinessType: '=?',
            hierarchyId: '=?',
            hierarchyBranchItem: '=?',
            hierarchyLocationList: '=?',
            disabled: '=?',
            defaultValue: '=?',
            rangeFilterYear: '=?',
            rangeFilterRange: '=?',
            filterList: '=?',
            customCriteria: '=?',
            checkBoxContentKey: '@?',
            emptyAsAll: '=?',
            fetchOnStart: '=?'
        };
        bindToController = true;
        controller = Meevo.Components.Controls.EmployeeMoverController;
        controllerAs = '$ctrl';
        require = [
            'meevoEmployeeMover', // self controller
            'ngModel'
        ];
        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            self.ngModel = ngModel;
            self.init();
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new EmployeeMover();
            };

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoEmployeeMover', EmployeeMover.factory());
}
